export default function CTA() {
  return (
    <section className="cta">
      <h2>Sẵn sàng học theo cách thông minh hơn?</h2>
      <p>
        Đừng học chăm hơn. Học đúng cách.
      </p>
      {/* <button className="btn primary large">Tạo tài khoản miễn phí</button> */}
    </section>
  );
}
